import { WORD_LENGTH } from '../../constants/settings'
import { WORD_COUNT } from '../../constants/countSpecific'
import { Cell } from './Cell'

export const EmptyRow = () => {
  const emptyCells = Array.from(Array(WORD_LENGTH * WORD_COUNT))

  return (
    <div className="flex justify-center mb-1 every-nth">
      {emptyCells.map((_, i) => (
        <Cell key={i} position={i} />
      ))}
    </div>
  )
}
